import moment from "moment"
import {
  SET_PO_LOADING,
  SET_PURCHASE_ORDERS,
  SET_TOTAL_PURCHASE_ORDERS,
  SET_TOTAL_PO_PAGES,
  SET_PO_DATE,
  SET_PO_SUPPLIER,
  SET_PO_COMMENTS,
  SET_PO_REMARKS,
  SET_PO_PRODUCTS,
  SET_PO_IR_NUMBER,
  CLEAR_NEW_PO,
  LOAD_PO_FOR_EDIT,
} from "../actions/purchaseOrder"

const initialState = {
  isLoading: false,
  purchaseOrders: [],
  totalPurchaseOrders: 0,
  totalPages: 0,
  newPO: {
    date: moment().format("YYYY-MM-DD"),
    supplierCode: "",
    comments: "",
    remarks: "",
    irNumber: "",
    poProducts: [],
  },
  isEditing: false,
  editingId: null,
}

const PurchaseOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PO_LOADING:
      return {
        ...state,
        isLoading: action.data,
      }

    case SET_PURCHASE_ORDERS:
      return {
        ...state,
        purchaseOrders: action.data,
      }

    case SET_TOTAL_PURCHASE_ORDERS:
      return {
        ...state,
        totalPurchaseOrders: action.data,
      }

    case SET_TOTAL_PO_PAGES:
      return {
        ...state,
        totalPages: action.data,
      }

    case SET_PO_DATE:
      return {
        ...state,
        newPO: { ...state.newPO, date: action.data },
      }

    case SET_PO_SUPPLIER:
      return {
        ...state,
        newPO: { ...state.newPO, supplierCode: action.data },
      }

    case SET_PO_COMMENTS:
      return {
        ...state,
        newPO: { ...state.newPO, comments: action.data },
      }

    case SET_PO_REMARKS:
      return {
        ...state,
        newPO: { ...state.newPO, remarks: action.data },
      }

    case SET_PO_IR_NUMBER:
      return {
        ...state,
        newPO: { ...state.newPO, irNumber: action.data },
      }

    case SET_PO_PRODUCTS:
      return {
        ...state,
        newPO: { ...state.newPO, poProducts: action.data },
      }

    case CLEAR_NEW_PO:
      return {
        ...state,
        newPO: {
          date: moment().format("YYYY-MM-DD"),
          supplierCode: "",
          comments: "",
          remarks: "",
          irNumber: "",
          poProducts: [],
        },
        isEditing: false,
        editingId: null,
      }

    case LOAD_PO_FOR_EDIT:
      return {
        ...state,
        isEditing: action.data.isEditing,
        editingId: action.data.editingId,
      }

    default:
      return state
  }
}

export default PurchaseOrderReducer
